import React from "react";

function Error404Page() {
  return (
    <div className="wrap-inner">
      <div className="layout-def with_bottom_area error">
        <div className="container">
          <div className="inner">
            <div className="cont">
              <h1>Error</h1>
              <div className="title1">404</div>
              <div className="title2">Server Contact Error</div>
              <div className="img_wrap">
                <img src="./static/images/common/img_etc_01@2x.png" alt="" />
              </div>
              <div className="text">
                지금 이 서비스와 연결할 수 없습니다.
                <br />
                문제를 해결하기 위해 열심히 노력하고 있습니다.
                <br />
                잠시 후 다시 확인해주세요.
              </div>
            </div>
            <div className="bottom_wrap btn_wrap">
              <a
                href="#null"
                className="btn btn-blue"
                // onClick={() => history.push(Url.SELECT_LEARNING)}
              >
                Home
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Error404Page;
